import forge from "node-forge";
import dayjs from "dayjs";

// Const
import Nuclias from "../const/nuclias";

class User {
  constructor() {
  }

  static setToken(token) {
    User.token = token;
  }

  static getTokenKeepAlive = () => {
    if (localStorage.getItem(Nuclias.localStorageKey.tokenKeepAlive) === 'true') {
      return true;
    } else {
      return false;
    }
  }

  static getTokenAndAliveTime() {
    const token = localStorage.getItem(Nuclias.localStorageKey.token);
    const tokenAliveTime = localStorage.getItem(Nuclias.localStorageKey.tokenAliveTime);
    const nowTime = dayjs(new Date());

    if (!token || (token && tokenAliveTime <= nowTime.unix())) {
      return null;
    }

    return {
      token: JSON.parse(token),
      tokenAliveTime: parseInt(tokenAliveTime)
    }
  }

  static encryptPassword(publicKey, password) {
    publicKey = '-----BEGIN RSA PUBLIC KEY-----' + publicKey + '-----END RSA PUBLIC KEY-----'

    const makePublicKey = forge.pki.publicKeyFromPem(publicKey);
    const plaintextPassword = forge.util.encodeUtf8(password);

    return encodeURI(forge.util.encode64(makePublicKey.encrypt(plaintextPassword)));
  }

  static saveTokenToLocalStoreage(token) {
    localStorage.setItem(Nuclias.localStorageKey.token, JSON.stringify(token));
  }

  static saveTokenKeepAliveToLocalStoreage(flag) {
    const tokenExpiredTime = dayjs(new Date()).unix() + Nuclias.maxTokenAliveTime;

    localStorage.setItem(Nuclias.localStorageKey.tokenKeepAlive, flag);
    localStorage.setItem(Nuclias.localStorageKey.tokenAliveTime, tokenExpiredTime);
  }

  static removeTokenLocalStoreage() {
    localStorage.removeItem(Nuclias.localStorageKey.token);
    localStorage.removeItem(Nuclias.localStorageKey.tokenKeepAlive);
    localStorage.removeItem(Nuclias.localStorageKey.tokenAliveTime);
  }
}

export default User;